<template>

    <div class="box box-solid">
        <div class="box-header">
            <h2 class="box-title">Contract {{ contract === null ? 'toevoegen' : 'wijzigen' }} voor gebruiker: {{ getUserFullname }}</h2>
        </div>
        <div class="box-body">
            <div class="form-group">
                <label>Gebruikersgroep</label>
                <p v-if="getUserGroupsForCurrentBusiness.length === 1" class="form-control-static">{{ getUserGroupsForCurrentBusiness[0].name }}</p>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-4">
                        <label for="type_id">Type:</label>
                        <select name="type_id" id="type_id" class="form-control" tabindex="1" v-model="contractPostData.type_id">
                            <option value="">-- Selecteer --</option>
                            <option v-for="(type, index) in types" :value="index">{{ type }}</option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <label for="functiongroup">Functieschaal:</label>
                        <select name="functiongroup" id="functiongroup" class="form-control" tabindex="1" v-model="contractPostData.functiongroup">
                            <option value="">-- Selecteer --</option>
                            <option v-for="group in groups" :value="group">{{ group }}</option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <label for="functionyear">Functiejaar:</label>
                        <input maxlength="2" type="number" name="functionyear" id="functionyear" class="form-control" v-model="contractPostData.functionyear">
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="duration">Looptijd:</label>
                <div class="radio">
                    <label for="duration">
                        <input type="radio" name="duration" id="duration" :checked="contractPostData.duration === 'set'" value="set" tabindex="1" @change="contractPostData.duration = 'set'" />
                        Bepaalde tijd
                    </label>
                </div>
                <div class="radio">
                    <label for="durationunset">
                        <input type="radio" name="duration" id="durationunset" :checked="contractPostData.duration === 'unset'" value="unset" tabindex="1" @change="contractPostData.duration = 'unset'" />
                        Onbepaalde tijd
                    </label>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="control-label">Start datum:</label>
                        <date-picker v-model="contractPostData.start" lang="en" format="DD-MM-YYYY"></date-picker>
                    </div>
                    <div class="col-sm-6" v-show="contractPostData.duration === 'set'">
                        <label class="control-label">Eind datum:</label>
                        <date-picker v-model="contractPostData.end" lang="en" format="DD-MM-YYYY"></date-picker>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label>Bruto salaris:</label>
                        <money v-model="contractPostData.salary" v-bind="money" tabindex="1" class="form-control"></money>
                    </div>
                </div>
            </div>
            <div class="form-group table-responsive">
                <table class="table">
                    <tbody>
                        <tr>
                            <td>Inhoudingen</td>
                            <td>Vakantietoeslag</td>
                            <td>Sociale lasten</td>
                        </tr>
                        <tr>
                            <td>
                                <div class="input-group">
                                    <input maxlength="2" type="number" name="deduction" class="form-control" v-model="contractPostData.deduction">
                                    <span class="input-group-addon">
                                    %
                                </span>
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <input maxlength="2" type="number" name="vacationbonus" class="form-control" v-model="contractPostData.vacationbonus">
                                    <span class="input-group-addon">
                                    %
                                </span>
                                </div>
                            </td>
                            <td>
                                <div class="input-group">
                                    <input maxlength="2" type="number" name="socialsecurity" class="form-control" v-model="contractPostData.socialsecurity">
                                    <span class="input-group-addon">
                                    %
                                </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6">
                        <label for="weeklyhours">Contract uren (week):</label>
                        <input type="number" name="weeklyhours" id="weeklyhours" value="" class="form-control disabled" disabled tabindex="1" :value="calcWeeklyHours" />
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label for="vacationhours">Vakantie uren per kalenderjaar:</label>
                            <input type="number" name="vacationhours" id="vacationhours" value="" class="form-control" tabindex="1" v-model="contractPostData.vacationhours" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" v-model='contractPostData.even_odd_weeks'>
                        Afwijkend patroon even/oneven weken
                    </label>
                </div>
            </div>
            <div class="form-group table-responsive">
                <table class="table">
                    <tbody>
                        <tr class="text-center">
                            <td v-if="contractPostData.even_odd_weeks"></td>
                            <td>Ma</td>
                            <td>Di</td>
                            <td>Wo</td>
                            <td>Do</td>
                            <td>Vr</td>
                            <td>Za</td>
                            <td>Zo</td>
                        </tr>
                        <tr>
                            <td v-if="contractPostData.even_odd_weeks">Even weken</td>
                            <td>
                                <input type="number" name="mo" class="form-control" v-model="contractPostData.hours.mo" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="tu" class="form-control" v-model="contractPostData.hours.tu" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="we" class="form-control" v-model="contractPostData.hours.we" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="th" class="form-control" v-model="contractPostData.hours.th" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="fr" class="form-control" v-model="contractPostData.hours.fr" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="sa" class="form-control" v-model="contractPostData.hours.sa" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="su" class="form-control" v-model="contractPostData.hours.su" tabindex="1" />
                            </td>
                        </tr>
                        <tr v-if="contractPostData.even_odd_weeks">
                            <td>Oneven weken</td>
                            <td>
                                <input type="number" name="mo" class="form-control" v-model="contractPostData.hours.mo_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="tu" class="form-control" v-model="contractPostData.hours.tu_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="we" class="form-control" v-model="contractPostData.hours.we_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="th" class="form-control" v-model="contractPostData.hours.th_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="fr" class="form-control" v-model="contractPostData.hours.fr_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="sa" class="form-control" v-model="contractPostData.hours.sa_odd" tabindex="1" />
                            </td>
                            <td>
                                <input type="number" name="su" class="form-control" v-model="contractPostData.hours.su_odd" tabindex="1" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="form-group">
                <div class="text-right">
                    <button type="button"
                        :class="{'btn btn-primary':true,'disabled':!canSubmit}"
                        :disabled="!canSubmit"
                        @click="onSubmit()"
                        tabindex="1"
                    >{{ contract === null ? 'Toevoegen' : 'Wijzigen' }}</button>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="handling">
            <i class="fa fa-refresh fa-spin"></i>
        </div>
    </div>

</template>

<script>

    import DatePicker from 'vue2-datepicker';
    import axios from 'axios';
    import {Money} from 'v-money';
    import moment from 'moment';

    export default {

        components: {
            DatePicker,
            Money,
        },

        computed: {
            calcWeeklyHours() {
                let hours = 0;
                for (let h in this.contractPostData.hours) {
                    if (this.contractPostData.hours.hasOwnProperty(h)) {
                        hours += parseFloat(this.contractPostData.hours[h]);
                    }
                }

                if (this.contractPostData.even_odd_weeks) {
                    return hours / 2;
                }

                return hours;
            },
            canSubmit() {
                return this.contractPostData.start !== '' &&
                    this.hasEnd &&
                    this.calcWeeklyHours !== 0 &&
                    this.type_id !== '' &&
                    this.contractPostData.functiongroup !== '';
            },
            getUserFullname() {
                if (this.user.middlename === null) {
                    return this.user.firstname + " " + this.user.lastname;
                } else {
                    return this.user.firstname + " " + this.user.middlename + " " + this.user.lastname;
                }
            },
            getUserGroupsForCurrentBusiness() {
                return this.usergroups;
            },
            hasEnd(){
                if (this.contractPostData.duration !== 'set') {
                    return true;
                }
                return this.end !== '';
            },

            postData() {
                let data = this.contractPostData;
                // Overwrite
                data.start = moment(data.start).format("YYYY-MM-DD");
                data.end = data.duration === 'set' ? moment(data.end).format("YYYY-MM-DD") : null;
                // Return
                return data;
            },
        },

        data() {
            return {
                contractPostData: {
                    deduction:0,
                    duration:'set',
                    end:'',
                    functiongroup:'',
                    functionyear:0,
                    salary:'0,00',
                    socialsecurity:0,
                    start:'',
                    type_id:"",
                    user_id:0,
                    usergroup_id:0,
                    vacationbonus:0,
                    vacationhours:0,
                    even_odd_weeks: false,
                    hours:{
                        mo:0,
                        tu:0,
                        we:0,
                        th:0,
                        fr:0,
                        sa:0,
                        su:0,
                        mo_odd:0,
                        tu_odd:0,
                        we_odd:0,
                        th_odd:0,
                        fr_odd:0,
                        sa_odd:0,
                        su_odd:0,
                    },
                },

                contract:null,
                groups:[],
                handling:false,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '€ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                types:[],
                weeklyhours:0,
                user:{},
                usergroups:[],
            }
        },

        methods: {
            onSubmit(){
                // Check if we can submit
                if (!this.canSubmit) {
                    return;
                }
                // Set handling
                this.handling = true;
                axios.post(this.postUri,this.postData)
                .then(response => {
                    if (response.data.success) {
                        this.$snotify.success('De contract gegevens zijn opgeslagen');
                        this.$router.push({
                            name:'hr.users.contracts',
                            params:{
                                id:response.data.data.user_uuid,
                            },
                        });
                        this.$emit('contractSaveCompleted');
                    } else {
                        this.$snotify.error('Er is een fout opgetreden bij het opslaan van de contract gegevens.');
                    }
                })
                .catch(() => this.$snotify.error('Er is iets fout gegaan bij het opslaan van dit contract'))
                .finally(() => this.handling = false);
            },
        },

        mounted() {
            this.groups = JSON.parse(this.functionGroups);
            this.types = JSON.parse(this.contractTypes);
            this.user = JSON.parse(this.userData);
            this.contractPostData.user_id = this.user.id;
            this.usergroups = JSON.parse(this.userGroupsData);
            if (this.contractData) {
                this.contract = true;
                let data = JSON.parse(this.contractData);
                data.start = new Date(data.start);
                if (data.end !== null) { data.end = new Date(data.end); }
                this.contractPostData = data;
            }
        },

        name: "HRContractsForm",

        props: {
            contractData: {
                type:String,
                default:null,
            },
            contractTypes: {
                required:true,
                type:String,
            },
            functionGroups:{
                required:true,
                type:String,
            },
            postUri: {
                required:true,
                type:String,
            },
            userData: {
                required:true,
                type:String,
            },
            userGroupsData: {
                required:true,
                type:String,
            },
        }
    }

</script>
